export const FETCH_POLE_BIDS = 'FETCH_POLE_BIDS'
export const FETCH_POLE_STATUSES = 'FETCH_POLE_STATUSES'
export const FETCH_POLE_QUANTITY = 'FETCH_POLE_QUANTITY'
export const FETCH_POLE_COEFFICIENTS = 'FETCH_POLE_COEFFICIENTS'
export const GET_POLE_BIDS = 'GET_POLE_BIDS'
export const GET_POLE_COEFFICIENTS = 'GET_POLE_COEFFICIENTS'
export const GET_POLE_LOADING = 'GET_POLE_LOADING'
export const GET_POLE_COEFFICIENTS_LOADING = 'GET_POLE_COEFFICIENTS_LOADING'
export const GET_POLE_PAGINATION = 'GET_POLE_PAGINATION'
export const GET_POLE_COEFFICIENTS_PAGINATION =
  'GET_POLE_COEFFICIENTS_PAGINATION'
export const GET_POLE_STATUSES = 'GET_POLE_STATUSES'
export const GET_POLE_QUANTITY = 'GET_POLE_QUANTITY'
export const SET_POLE_BIDS = 'SET_POLE_BIDS'
export const SET_POLE_COEFFICIENTS = 'SET_POLE_COEFFICIENTS'
export const SET_POLE_LOADING = 'SET_POLE_LOADING'
export const SET_POLE_COEFFICIENTS_LOADING = 'SET_POLE_COEFFICIENTS_LOADING'
export const SET_POLE_STATUSES = 'SET_POLE_STATUSES'
export const SET_POLE_QUANTITY = 'SET_POLE_QUANTITY'
export const UPDATE_POLE_BID = 'UPDATE_POLE_BID'
export const UPDATE_POLE_COEFFICIENT = 'UPDATE_POLE_COEFFICIENT'
